/* src/app/modules/settings/components/change-password-form/change-password-form.component.scss */
.change-main-container .change-pass-form ::ng-deep .p-inputwrapper {
  width: 100%;
}
.change-main-container .change-pass-form ::ng-deep .p-inputtext {
  font-size: 0.75rem;
  padding: 0.5rem;
  width: 100%;
}
.change-main-container .change-pass-form ::ng-deep .p-button {
  width: 100%;
  padding: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.adapt {
  height: 100%;
}
.password-policy {
  flex: 1;
  justify-content: center;
}
.password-policy ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 2;
}
.password-policy ul li {
  display: flex;
  margin-top: 0.5rem;
  gap: 0.5rem;
  align-items: center;
}
.password-policy ul li .password-policy-check-icon.green {
  color: green;
}
.password-policy ul li .password-policy-check-icon.default {
  color: var(--surface-400);
}
.password-policy ul .password-error {
  animation-name: moveLeftToRight;
  animation-duration: 0.6s;
  animation-iteration-count: 1;
}
@keyframes moveLeftToRight {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  25% {
    transform: translateX(-40px);
  }
  50% {
    transform: translateX(100px);
  }
  75% {
    transform: translateX(-40px);
  }
  100% {
    opacity: 1;
    transform: translate(0);
  }
}
/*# sourceMappingURL=change-password-form.component.css.map */
